import React from "react";

const styles = {
  containerStyle: {
    marginTop: "30px"
  },
  headingStyle: {
    fontSize: "16px",
    fontWeight: "500",
    margin: "0 0 10px"
  },
  descriptionStyle: {
    fontSize: "13px",
    fontWeight: "300"
  }
};

const ConfirmationPolicy = props => {
  return (
    <div style={styles.containerStyle}>
      <h3 style={styles.headingStyle}>Confirmation Policy</h3>
      <p style={styles.descriptionStyle}>{props.customerConfirmationPolicy}</p>
    </div>
  );
};

export { ConfirmationPolicy };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/ComfirmationPolicy.js